function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.1818 10.6364V19C20.1818 20.6569 18.8387 22 17.1818 22H5C3.34315 22 2 20.6568 2 19V6.81818C2 5.16132 3.34315 3.81818 5 3.81818H13.3636",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.1818 14.0454L22 2.22725",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3182 2C16.5 2 20.3333 2 22.2273 2V7.68182",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgExternalLink = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExternalLink, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/External-link.118e9824.svg";
export { ForwardRef as ReactComponent };